export class EmptyPurchasesError extends Error {
    constructor() {
        super('Empty purchases');
    }
}
